export const HOME_PATH = "/"
export const COMPONENTS_PATH = "/components"
export const LOGIN_REGISTER_PATH = "/connexion"
export const LLI_LOGIN_REGISTER_PATH = "/connexion-lli"
export const PROPERTIES_PATH = "/logements"
export const PROPERTIES_MAP_PATH = PROPERTIES_PATH + "/recherche"
export const PROPERTY_DETAIL_PATH = "/logements/:id"
export const ARTICLE_BY_ID_PATH = "/articles/:id"
export const NEWS_PATH = "/actualites"
export const JOIN_US_PATH = "/nous-rejoindre"
export const OFFER_DETAIL_PATH = "/offres/:id"
export const COMPLEX_DETAIL_PATH = "/residences/:id"

export const EDITORIAL_PATH = "/editorial/:groupUrlKey/:pageUrlKey"
export const FAQ_PATH = "/faq"
export const DISCOVER_PATH = "/nous-decouvrir"
export const OUR_HOUSING_STOCK_PATH = "/notre-parc-immobilier"
export const CONTACT_US_PATH = "/nous-contacter"

export const AGENCIES_PATH = "/nos-agences"
export const AGENCY_DETAIL_PATH = AGENCIES_PATH + "/:agencyKey"

export const CONNECTED_HOUSINGS_PATH = "/nos-logements-connectes"
export const CONNECTED_HOUSINGS_SPECIFIC_PATH = CONNECTED_HOUSINGS_PATH + "/:connectedHousingUrlKey"

export const OUR_COMMITMENTS_PATH = "/nos-engagements"
export const OUR_COMMITMENTS_SPECIFIC_PATH = OUR_COMMITMENTS_PATH + "/:commitmentUrlKey"

export const PRIVACY_POLICY_PATH = "/politique-de-confidentialite"
export const LEGAL_MENTIONS_PATH = "/mentions-legales"
